import React from 'react'
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
const faqs = [
    {
        question: "Q1. Can I do internship or Practice as a doctor in india without FMGE?",
        answer: "No, you cannot do an internship or practice as a doctor in India without clearing the FMGE (Foreign Medical Graduate Examination).",
    },
    {
        question: "Q2. How many hospitals providing FMGE internship in India?",
        answer: "As of 2025, the National Medical Commission (NMC) has approved approximately 675 hospitals across India for Foreign Medical Graduates (FMGs) to undertake their Compulsory Rotating Medical Internship (CRMI).",
    },
    {
        question: "Q3. Why the FMGE passing rate is low ?",
        answer: "The FMGE (Foreign Medical Graduate Examination) passing rate is low—often below 20–25%—due to a combination of the following key factors:\n1. Quality of Foreign Medical Education\n2. Curriculum Mismatch\n3. Lack of Proper Preparation\n4. Limited Clinical Exposure\n 5. Language and Teaching Issues\n6. Exam Pattern and Difficulty\n 7. No Upper Limit on FMG Admissions",                          
    },
    
    {
        question:"Q4.How many attempts are allowed for FMGE?",
        answer:"As of now, there is no limit on the number of attempts for the Foreign Medical Graduate Examination (FMGE). Candidates can appear for the exam as many times as needed until they pass"
    },
    {
        question:"Q5.Steps after passing the FMGE ?",
        answer:"After passing the FMGE (Foreign Medical Graduate Examination), here are the steps you need to follow to begin medical practice in India:\n1. Obtain FMGE Pass Certificate\n 2. Apply for Provisional Registration with the State Medical Council\n 3.Complete Compulsory Rotatory Internship (if required)\n 4.Apply for Permanent Registration with State Medical Council\n 5.Start Practice or Prepare for PG (NEET-PG/NExT)",            
    }
];

export default function FaqSection() {

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <>
            <div className="bg-white py-12 px-6 sm:px-12 md:px-24">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4 max-w-4xl mx-auto">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border-b pb-4">
                            <button
                                className="w-full flex justify-between items-center text-left"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span className="text-lg font-semibold text-richblack-900">{faq.question}</span>
                                {openIndex === index ? (
                                    <ChevronUp className="h-5 w-5 text-gray-500" />
                                ) : (
                                    <ChevronDown className="h-5 w-5 text-gray-500" />
                                )}
                            </button>
                            {openIndex === index && (
                                <p className="mt-2 text-richblack-700 whitespace-pre-line">{faq.answer}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>

        </>
    )
}
